import Lottie from 'lottie-react';
import animationData from '../../assets/data.json';
import { SpinnerProps } from '@/shared/types/spinner';
import { cn } from '@/shared/utils/cn';

/**
 * Spinner - Componente de spinner de carga animado
 *
 * Componente que muestra una animación de carga usando Lottie.
 * Útil para indicar que una operación está en progreso.
 *
 * @example
 * ```tsx
 * // Spinner por defecto
 * <Spinner />
 *
 * // Spinner personalizado
 * <Spinner size={48} loop={true} />
 *
 * // Spinner sin loop
 * <Spinner size={64} loop={false} />
 * ```
 *
 * @see {@link SpinnerProps} para la lista completa de props
 */
const Spinner = ({ size = 96, loop = true, style, className }: SpinnerProps) => {
  return (
    <div
      className={cn('ui-imj', className)}
      style={{
        width: size,
        height: size,
        ...style,
      }}
    >
      <Lottie animationData={animationData} loop={loop} />
    </div>
  );
};

export default Spinner;
